<script>

	import moment from 'moment'
	import ArticleOverview from '@/components/ArticleOverview'
	import BlogishEntries from '@/components/BlogishEntries'

	const FEATURED_SLUG = `preparing-for-assessments`

	export default {
		metaInfo () {
			return this.$generateMetaInfo({
				title: `StudySync Blog`,
				description: `Stay up to date on StudySync news, insights and support via our StudySync Blog. Entries includes District and Teacher Features, our Student Media Award Winners, helpful articles on using StudySync in the classroom, and more.`,
				image: 'https://www.studysync.com/static/homepage3.jpg'
			})
		},
		render () {
			return (
				<BlogishEntries
					variables={{
						section: 'blog'
					}}
					render={({ ready, entries }) => {
						if(!ready) {
							return null
						}
						const featured = entries.find((entry) => entry.slug === FEATURED_SLUG)
						return (
							<ArticleOverview
								featured={() => (
									<ArticleOverview.Featured
										entry={featured}
										entryName="blogEntry"
										render={({ entry, Prehead, Title, Intro, Author, Cta }) => (
											<div class="featured">
												<Prehead>Featured Blog Article</Prehead>
												<Title>{entry.title}</Title>
												<Author />
												<Intro domPropsInnerHTML={entry.intro} />
												<Cta>Read Article</Cta>
											</div>
										)}
									/>
								)}
								listings={() => (
									<ArticleOverview.Listings
										entries={entries}
										entryName="blogEntry"
										meta={(entry) => moment(entry.postDate).format('LL')}
									/>
								)}
							/>
						)
					}}
				/>
			)
		}
	}

</script>

<style lang="scss" scoped>
	.featured {
		max-width:600px;
	}
</style>



// WEBPACK FOOTER //
// src/routes/blog/index.vue